var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-327.000000, -47.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.835823,27.6881834 C124.054004,27.8586338 124.054462,28.1409707 123.838759,28.3098332 L119.449535,31.8665204 C119.238109,32.0442266 118.886568,32.0442266 118.669236,31.8681148 C118.459284,31.6983809 118.459725,31.4168676 118.670275,31.2403141 L122.129074,28.4427785 L110.544709,28.4427785 C110.242358,28.4427785 110,28.2427938 110,27.9971383 C110,27.7526488 110.240955,27.5572575 110.544852,27.5568598 L122.129242,27.5568599 L118.669236,24.7531053 C118.459399,24.583464 118.459399,24.3019186 118.669119,24.1319759 C118.886251,23.9560264 119.236627,23.955775 119.448513,24.1326202 L123.835823,27.6881834 Z",
    id: "Shape",
    transform: "translate(117.000000, 28.000000) rotate(-360.000000) translate(-117.000000, -28.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8aae4e38.svg";
export { ForwardRef as ReactComponent };